import { useCallback } from 'react';
import { RootState } from '../store';
import * as BancaActions from '../store/Banca.reducer';
import { useAppDispatch, useAppSelector } from './hooks';

export default function useBancas() {
  const dispatch = useAppDispatch();

  const banca = useAppSelector((state: RootState) => state.banca.banca);

  const bancas = useAppSelector((state: RootState) => state.banca.list);

  const fetching = useAppSelector((state: RootState) => state.banca.fetching);

  const fetchBancas = useCallback(() => {
    dispatch(BancaActions.getTodasAsBancas());
  }, [dispatch]);

  const getBanca = useCallback(
    (objeto:any) => {
      dispatch(BancaActions.getBanca(objeto));
    },
    [dispatch]
  );

  return {
    fetchBancas,
    getBanca,
    banca,
    bancas,
    fetching,
  };
}
